import c from 'classnames';
import React, { PropsWithChildren } from 'react';
import { Helmet } from 'react-helmet';
import './PlanInfo.css';

const InfoPage = ({ children, className }: PropsWithChildren<{ className?: string }>) => {
    return (
        <div className={c('InfoPage', className)}>
            <Helmet>
                <meta name="robots" content="noindex, nofollow" />
            </Helmet>
            {children}
        </div>
    );
};

export default InfoPage;
